import { useQuery } from '@tanstack/react-query';
import { businessPackageRequest } from '../../business/BusinessPackageRequest';
import { queryKeys } from '../../constants/queryKeys';
import { IdBasedHookOptions } from './types';

function useCheckIfPackageFavorited({
  id,
  enabled = true,
}: IdBasedHookOptions) {
  const QUERY_KEY = [queryKeys.businessPackageIsFavorited, id, enabled];

  return useQuery<boolean, Error>({
    queryKey: QUERY_KEY,
    queryFn: () => businessPackageRequest.checkIfFavorited(id),
    enabled,
  });
}

export default useCheckIfPackageFavorited;
